const LOAD_AUTO_UPDATES = "autoUpdates:LOAD_AUTO_UPDATES";
const SHOW_UPDATE_MODAL = "autoUpdates:SHOW_UPDATE_MODAL";
const HIDE_UPDATE_MODAL = "autoUpdates:HIDE_UPDATE_MODAL";
const SHOW_UPDATE_CHECK = "autoUpdates:SHOW_UPDATE_CHECK";
const HIDE_RELEASE_NOTES = "autoUpdates:HIDE_RELEASE_NOTES";

export const actionTypes = {
  LOAD_AUTO_UPDATES,
  SHOW_UPDATE_MODAL,
  HIDE_UPDATE_MODAL,
  SHOW_UPDATE_CHECK,
  HIDE_RELEASE_NOTES
};

const loadAutoUpdates = data => {
  return {
    type: LOAD_AUTO_UPDATES,
    data
  };
};

const showUpdateModal = () => {
  return {
    type: SHOW_UPDATE_MODAL
  };
};

const hideUpdateModal = () => {
  return {
    type: HIDE_UPDATE_MODAL
  };
};

const showUpdateCheck = data => {
  return {
    type: SHOW_UPDATE_CHECK,
    data
  };
};

const hideReleaseNotes = () => {
  return {
    type: HIDE_RELEASE_NOTES
  };
};

export default {
  loadAutoUpdates,
  showUpdateModal,
  hideUpdateModal,
  showUpdateCheck,
  hideReleaseNotes
};
